import axios from 'axios';
import config from '../../config/app';

const baseApiHeaders = { 'X-PagerDuty-Api-Local': 1 };

export const getNotificationRules = user => axios({
  method: 'GET',
  baseURL: '/api/v1/',
  url: `/users/${user.id}/notification_rules`,
  headers: baseApiHeaders
});

export const postNotificationRule = (user, contactMethod) => axios({
  method: 'POST',
  baseURL: '/api/v1/',
  url: `/users/${user.id}/notification_rules`,
  headers: baseApiHeaders,
  data: {
    notification_rule: {
      type: 'assignment_notification_rule',
      start_delay_in_minutes: 0,
      contact_method: { id: contactMethod.id, type: contactMethod.type },
      urgency: 'high'
    }
  }
});

export const deleteNotificationRule = (user, notificationRule) => axios({
  method: 'DELETE',
  baseURL: config.BASE_PATH,
  url: `/api/v1/users/${user.id}/notification_rules/${notificationRule.id}`,
  headers: baseApiHeaders
});
